import { headers } from "@utils/utils";

const usePapelStore = defineStore("papel", () => {
  // state
  const papel = ref({
    id: null,
    nombre: null,
    ancho: 0,
    alto: 0,
    tipo: null,
  });

  const papels = ref([]);

  // getters

  const draft = computed(() => clone(papel.value));

  // mutations

  const setPapel = (payload) => {
    papel.value = payload;
  };

  const clear = () => {
    papel.value = {
      id: null,
      nombre: null,
      ancho: 0,
      alto: 0,
      tipo: null,
    };
  };

  const setPapeles = (payload) => (papels.value = payload);

  // actions
  const fetch = (papel_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/papels/${papel_id}/fetch-data`)
        .then(({ data }) => {
          setPapel(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/papels/fetch-data`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardar = (datos) => {
    let formData = new FormData();
    Object.keys(datos).forEach((k) => {
      formData.append(k, datos[k]);
    });

    return new Promise((resolve, reject) => {
      if (datos.id) {
        formData.append("_method", "PUT");

        axios
          .post(`/api/papels/${datos.id}`, formData, { headers })
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      } else {
        axios
          .post(`/api/papels`, formData, { headers })
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (plan_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/papels/${plan_id}`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const fetchSelectList = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/papels/select-list`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  return {
    papel,
    draft,
    setPapel,
    setPapeles,
    fetch,
    clear,
    fetchData,
    guardar,
    eliminar,
    fetchSelectList,
  };
});

export default usePapelStore;
